import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as people from '../../people'

export const RESOURCE = {
  payload: {
    description:
      'Represents an individual person in any capacity. This could be an employee, student, alumnus, donor, collaborator from another institution, etc.',
    dimension: people.RESOURCE.payload,
    level: 0,
    name: 'Person',
    partialId: PartialId.Standard.create('person'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
